import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  IconButton,
} from "@material-ui/core";
import DocumentPreview from "components/_refactor/document-preview";
import { Close } from "@mui/icons-material";

export default function DialogDetail({ url, onClose }) {
  return (
    <Dialog open maxWidth="md">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            Preview do Arquivo
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        <Box
          mb={2}
          border="1px solid #e0e0e0"
          borderRadius={4}
          overflow="hidden"
        >
          <DocumentPreview url={url} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
